import {KEY_POINT_INCOME, RUINS_INCREASED_INCOME} from "../../../configs/income";
import {isPlayerPolicy} from "../../factions/isPlayerPolicy";
import {POLICIES} from "../../../constants/policies";
import {checkIfRoundWithIncreasedRuinsIncome} from "./checkIfRoundWithIncreasedRuinsIncome";
import {POLICY_FANATICISM_RUINS_WIN_POINTS_INCOME_BONUS} from "../../../configs/policy/fanaticism";

/**
 * Доход руин (очки) по слагаемым — для расшифровки дохода игрока (панель
 * статов в шапке); calcRuinsIncome — их сумма
 *
 * @param ruinsToken
 * @param player
 * @param round
 * @param ruinsIncomeRoundLimit - лимит раундов для окна увеличенного дохода,
 *   getRuinsIncomeRoundLimit(gameState); null — окна нет
 * @returns {{base: number, isIncreased: boolean, fanaticism: number, total: number}}
 */
export const calcRuinsIncomeDetails = (ruinsToken, player, round, ruinsIncomeRoundLimit) => {
  const isIncreased = checkIfRoundWithIncreasedRuinsIncome(round, ruinsIncomeRoundLimit);

  const base = isIncreased ? RUINS_INCREASED_INCOME[ruinsToken] : KEY_POINT_INCOME[ruinsToken];
  const fanaticism = isPlayerPolicy(player, POLICIES.FANATICISM) ? POLICY_FANATICISM_RUINS_WIN_POINTS_INCOME_BONUS : 0;

  return {
    base,
    isIncreased,
    fanaticism,
    total: base + fanaticism,
  };
};

export const calcRuinsIncome = (ruinsToken, player, round, ruinsIncomeRoundLimit) => (
  calcRuinsIncomeDetails(ruinsToken, player, round, ruinsIncomeRoundLimit).total
);
